module.exports = __webpack_public_path__ + "img/11_51.59ffa655.png";